const config = {
    siteName: "Kshitij Techno",
    menuItem1: "Home",
    menuItem2: "Products",
    menuItem3: "Learnings",
    menuItem4: "Videos",
    menuItem5: "Quizes",
    contact: "Contact",
    disclaimer: "Disclaimer",
    createby: "Created by : Kshitij Wardhan Ahirwar",
    url_linkedIn:"https://www.linkedin.com/in/kshitijwardhan/",
    url_facebook:"https://www.facebook.com/kshitij.wardhanahirwar/",
    url_instagram:"https://www.instagram.com/kshitijwardhan/",
    
    home_showDialog: false,
    home_dialog_title: "Request",
    home_dialog_content:"This site is under development. I want to know the public reviews so I can make it more better. Please explore the whole site and provide your valuable feedback. For giving feedback you can navigate to Contact page.",
    home_showIntro: true,

    contactus_modeldata_title:  "Information",
    contactus_modeldata_careers_title:  "Want to contribute?",
    contactus_modeldata_careers_message:  "If you want to contribute towards our work and vision. You are always welcomed. Please feel free to reach out anytime.",
    contactus_modeldata_data:"Whatsapp us on +91-9036623883",
    
    uri_hybrisInterview : '/learnings/hybris/hybris-interview',
    uri_hybrisLocalSetup : '/learnings/hybris/local-setup',
    uri_hybrisProjectImportIntellij : '/learnings/hybris/import-project-intellij',
    uri_itemsXml : '/learnings/hybris/hybris-data-modeling',
    
    uri_javaInterview : '/learnings/java/java-interview',
    uri_javaLogical : '/learnings/java/java-logical',
    uri_hybrisquiz:'/quizes/hybris-quiz',
    uri_freerecharge:'/quizes/free-recharge',
    uri_products_dixnary:'/products/dixnary',
    uri_products_gharkharcha:'/products/gharkharcha',
    uri_privacy_gharkharcha:'/privacy/gharkharcha',

    youtube_modeldata_message: "To to show your support please visit <a href='https://www.youtube.com/@kshitijwardhan' target='_blank' rel='noopener noreferrer'> Kshitij Wardhan Ahirwar </a> my youtube channel. Please do watch, like, comment, share & subscribe to my channel",
    youtubeVideosTechnology: [
      {
        videoId: "dOEf3qabuW0?si=gHjS9ucy5ZmReyqV",
        title: "Git tutorial for beginners and experienced software professionals",
        content:
          "Hey viewers this video contains the tutorial for git. After watching it you will get to know the various commands of git. Its specially created for freshers and I have tried to keep explanation very simple. Experienced developer can also refer this guide.",
      },
      {
        videoId: "1-2v8XEIYsM?si=51-H8_vCwwgAevRL",
        title: "Altimetrik wfh kit unboxing",
        content: "Unboxing of WFH kit from Altimetrik.",
      },
    ],
    youtubeVideosMisc: [
      {
        videoId: "EpGZ5Be603c?si=rNatqHZjoCEDCAVc",
        title: "Glimpses of Sethani Ghat Narmadapuram Madhya Pradesh",
        content:
          "Sethani Ghat is located at Narmada river bank, District Narmadapuram Madhya Pradesh. Nice place to visit. We can best visit the place either morning or evening so aarti can be attended. I went to this trip on 5th April 2023.",
      },
      {
        videoId: "ksb6Lh82yQs?si=TzhAL68ymVLuBMEW",
        title: "Besli Dam Gohad",
        content: "Besli Dam Gohad",
      },
    ],
    clientCommentDisplay:"https://docs.google.com/spreadsheets/d/e/2PACX-1vTd1pmnxR9m5aMyIVQ5uaIWY9OXW2T3zf4eszQLDVvlfslmGqhV3yKlHtHI_2HRc1P7x5Vy5U9ZgFYM/pub?gid=508978835&single=true&output=csv",
  
  };
  
export default config;